import React from 'react';
import 'react-simple-flex-grid/lib/main.css';
import { Container } from '../../components/_styled/Grid';
import './SettingsLayout.scss';

const SettingsLayout = ({ children }) => {
    return (
        <div className="Settings">
            <Container>
                {children}
            </Container>
        </div>
    );
};

export default SettingsLayout;